import { Injectable } from '@angular/core';
import { standardCommand } from '../../../core/model/command';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { RentLossExportCommandHandler } from './export-rent-loss-command-handler.service';

@Injectable()
export class RentLossCommandHandlerResolver extends CommandHandlerResolver {
  constructor(editRentLoss: EditCommandHandler, exportCmd: RentLossExportCommandHandler) {
    super();
    this.addHandler(standardCommand.edit, editRentLoss);
    this.addHandler(standardCommand.export, exportCmd);
  }
}
